import { BaseContent, ContentTypeEnum, Hint, Id } from '../../../types'

// export interface PuzzleContent extends BaseContent {
//   type: `${ContentTypeEnum.Puzzle}`
//   fileNames: string[]
//   filePath?: string
// }

export enum PuzzleTypeEnum {
  Text = 'text',
  Grid = 'grid',
  Vector = 'vector',
}

export type PuzzleType = `${PuzzleTypeEnum}`

export type PuzzleContent = TextPuzzle | GridPuzzle | VectorPuzzle

export interface BasePuzzle {
  id: string
  type: `${ContentTypeEnum.Puzzle}`
  puzzleType: PuzzleType
  question: string
  successMsg?: string
  failMsg?: string
  hints?: Hint[]
  attempts?: number
  solved?: boolean
}

// Dossier stores a summary of the puzzles statuses
export type DossierPuzzle = Omit<
  BasePuzzle,
  'type' | 'puzzleType' | 'question' | 'successMsg' | 'failMsg'
> & {
  hintIds: Id[]
}

export interface TextPuzzle extends BasePuzzle {}

export interface GridPuzzle extends BasePuzzle {
  fileNames: string[]
  filePath?: string
}

export interface VectorPuzzle extends BasePuzzle {
  fileNames: string[]
  filePath?: string
}
